import {Component, computed, inject, model} from "@angular/core";
import {KeyValuePipe} from "@angular/common";
import {Drawer} from "primeng/drawer";
import {Button} from "primeng/button";
import {Panel} from "primeng/panel";
import {ElementTypes, ElementTypesDescription} from "@entities/widget-element";
import {
    PreviewBarChartComponent,
    PreviewDeviceStateComponent,
    PreviewGaugeChartComponent,
    PreviewLineChartComponent,
    PreviewSingleValueComponent
} from "@shared/ui";
import {WidgetConstructorStore} from "../../store/widget-constructor-store";

@Component({
    selector: "constructor-add-element-drawer",
    imports: [
        Drawer,
        Button,
        KeyValuePipe,
        Panel,
        PreviewLineChartComponent,
        PreviewBarChartComponent,
        PreviewGaugeChartComponent,
        PreviewDeviceStateComponent,
        PreviewSingleValueComponent
    ],
    templateUrl: "./add-element-drawer.component.html",
    styleUrl: "./add-element-drawer.component.scss"
})
export class AddElementDrawerComponent {
    readonly store = inject(WidgetConstructorStore);

    readonly visible = model(false);
    readonly firstPossiblePosition = computed(() => this.store.firstPossiblePosition());
    readonly widget = computed(() => this.store.editingWidget());

    readonly elementTypes = ElementTypes;
    readonly elementDescr = ElementTypesDescription;

    addElement(type: ElementTypes) {
        this.store.addEditingWidgetElement(type, this.firstPossiblePosition());
    }
}
